import type { HTMLAttributes } from 'react';
import type { MentionUser } from '../../types';
import { getMentionName } from '../../utils';
import classes from './index.module.scss';

export interface MentionBaseProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'onClick'> {
  user: MentionUser;
  selected?: boolean;
  filled?: boolean;
  dot?: 'hollow' | 'solid';
  normal?: boolean;
  children?: React.ReactNode;
  onClick?: (user: MentionUser, event: React.MouseEvent<HTMLSpanElement>) => void;
}

export default function MentionBase({
  selected,
  filled,
  dot,
  normal,
  user,
  children,
  onClick,
  ...attributes
}: MentionBaseProps) {
  const children_ = useMemo(() => {
    if (children) {
      return children;
    }

    return getMentionName(user);
  }, [children, user]);

  return (
    <span
      contentEditable={false}
      className={cls(
        classes.mention_base,
        selected && classes.focus,
        filled && classes.filled,
        dot && classes[dot],
        normal && classes.normal
      )}
      onClick={(event) => onClick?.(user, event)}
      {...attributes}
    >
      {children_}
    </span>
  );
}
